module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/commute/commute.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/commute/commute.component.css
// module chunks = main